<template>
  <div class="rewards-times" :class="cssType">
    <div class="title" :class="locale"></div>
    <div class="table">
      <div class="column" v-for="item in state.rewardList" :key="item.mergePrdCount">
        <div class="row">
          <span class="sub-row-1">
            {{ item.mergePrdCount }}
          </span>
          <span class="sub-row-2">
            {{ $t('payment.product.diamond') }}
          </span>
        </div>
        <div class="row">
          {{ item.collectTimesLimit }} {{ $t('accumRecharge.rewardsTimes.times') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, reactive } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  rewardList: {
    type: Array,
    default: () => []
  }
})
console.log(props.rewardList) // 服务端返回的奖励列表，现在改成前端写死
const state = reactive({
  rewardList: [
    {
      mergePrdCount: 500,
      collectTimesLimit: 3
    },
    {
      mergePrdCount: 1000,
      collectTimesLimit: 2
    },
    {
      mergePrdCount: 2500,
      collectTimesLimit: 1
    },
    {
      mergePrdCount: 5000,
      collectTimesLimit: 1
    },
    {
      mergePrdCount: 10000,
      collectTimesLimit: 1
    }
  ]
})
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
